import React, { useState } from "react";

function Navbar() {
  // State untuk mengontrol visibilitas menu di mobile view
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-gsf-sage/80 backdrop-blur-md py-4 px-4 sm:px-8">
      <div className="mx-auto max-w-7xl">
        {/* Kontainer Utama Nav */}
        <nav className="border-2 border-slate-900 bg-white rounded-2xl px-6 py-4 flex items-center justify-between shadow-[6px_6px_0px_0px_#ccd5ae] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[10px_10px_0px_0px_#d4a373]">
          {/* Logo / Brand */}
          <div>
            <a
              href="#"
              className="text-xl font-black tracking-tight text-slate-900 hover:text-gsf-bronze transition-colors"
            >
              Gunjo
              <span className="text-gsf-bronze hover:text-slate-900">.dev</span>
            </a>
          </div>

          {/* Menu Navigasi Utama (Desktop - Mengarah ke Section ID) */}
          <nav className="hidden lg:flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-slate-600">
            <a
              href="#projects"
              className="px-3 py-2 rounded-xl hover:bg-gsf-sand/30 hover:text-slate-900 hover:font-bold transition-all"
            >
              Projects
            </a>
            <span className="text-slate-300 select-none">•</span>

            <a
              href="#experience"
              className="px-3 py-2 rounded-xl hover:bg-gsf-sand/30 hover:text-slate-900 hover:font-bold transition-all"
            >
              Experience
            </a>
            <span className="text-slate-300 select-none">•</span>

            <a
              href="#expertise"
              className="px-3 py-2 rounded-xl hover:bg-gsf-sand/30 hover:text-slate-900 hover:font-bold transition-all"
            >
              Expertise
            </a>
            <span className="text-slate-300 select-none">•</span>

            <a
              href="#about"
              className="px-3 py-2 rounded-xl hover:bg-gsf-sand/30 hover:text-slate-900 hover:font-bold transition-all"
            >
              About
            </a>
            <span className="text-slate-300 select-none">•</span>

            {/* <a
              href="#blog"
              className="px-3 py-2 rounded-xl hover:bg-gsf-sand/30 hover:text-slate-900 transition-all"
            >
              Blog
            </a> */}
          </nav>

          {/* Sisi Kanan: Tombol CTA Desktop & Hamburger Trigger Mobile */}
          <div className="flex items-center gap-4">
            {/* Tombol Contact Desktop */}
            <a
              href="#contact"
              className="hidden sm:inline-flex border-2 border-slate-900 bg-slate-900 px-4 py-2 text-xs font-bold uppercase tracking-wider text-white rounded-xl shadow-[3px_3px_0px_0px_#faedcd] transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[5px_5px_0px_0px_#d4a373] active:translate-y-0"
            >
              Contact
            </a>

            {/* Hamburger Button Mobile */}
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="lg:hidden border-2 border-slate-900 p-2 rounded-xl bg-white hover:bg-gsf-sand/30 active:translate-y-0.5 transition-all focus:outline-none"
              aria-label="Toggle Menu"
            >
              <svg
                className="w-5 h-5 text-slate-900"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2.5"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isOpen ? (
                  <path d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </nav>

        {/* ─── PANEL MENU MOBILE (Dropdown / Drawer) ─── */}
        {isOpen && (
          <div className="mt-3 lg:hidden border-2 border-slate-900 bg-white rounded-2xl p-4 shadow-[4px_4px_0px_0px_#ccd5ae] animate-in fade-in slide-in-from-top-2 duration-200">
            <div className="flex flex-col gap-2 text-xs font-bold uppercase tracking-wider text-slate-600">
              <a
                href="#projects"
                onClick={() => setIsOpen(false)}
                className="px-4 py-3 rounded-xl hover:bg-gsf-sand/30 hover:text-slate-900 transition-all border border-transparent hover:border-slate-900/10"
              >
                Projects
              </a>
              <a
                href="#experience"
                onClick={() => setIsOpen(false)}
                className="px-4 py-3 rounded-xl hover:bg-gsf-sand/30 hover:text-slate-900 transition-all border border-transparent hover:border-slate-900/10"
              >
                Experience
              </a>
              <a
                href="#expertise"
                onClick={() => setIsOpen(false)}
                className="px-4 py-3 rounded-xl hover:bg-gsf-sand/30 hover:text-slate-900 transition-all border border-transparent hover:border-slate-900/10"
              >
                Expertise
              </a>
              <a
                href="#about"
                onClick={() => setIsOpen(false)}
                className="px-4 py-3 rounded-xl hover:bg-gsf-sand/30 hover:text-slate-900 transition-all border border-transparent hover:border-slate-900/10"
              >
                About
              </a>
              {/* <a
                href="#blog"
                onClick={() => setIsOpen(false)}
                className="px-4 py-3 rounded-xl hover:bg-gsf-sand/30 hover:text-slate-900 transition-all border border-transparent hover:border-slate-900/10"
              >
                Blog
              </a> */}

              {/* Tombol Contact Mobile */}
              <a
                href="#contact"
                onClick={() => setIsOpen(false)}
                className="mt-2 text-center border-2 border-slate-900 bg-slate-900 py-3 text-white rounded-xl shadow-[3px_3px_0px_0px_#faedcd] active:translate-y-0.5 transition-all"
              >
                Contact Me
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}

export default Navbar;
